<template>
  <main class="page">
    <div class="page__main main">
      <h2 class="main__heading section-header">カテゴリ</h2>
      <TagList
        :selectedTagId="selectedTagId"
        :tags="rootCategories"
        :allTags="categories"
        @selectTag="selectTag"
        @createTag="createTag"
      />
      <TagCreateForm
        tagType="category"
        placeholder="新規カテゴリを作成"
        @createTag="createTag"
      />
      <h2 class="main__heading section-header">タグ</h2>
      <TagList
        :selectedTagId="selectedTagId"
        :tags="tagTypeTags"
        :allTags="tagTypeTags"
        @selectTag="selectTag"
      />
      <TagCreateForm
        tagType="tag"
        placeholder="新規タグを作成"
        @createTag="createTag"
      />
    </div>
    <div class="page__side">
      <TagEditor
        :tag="selectedTag"
        :allCategories="categories"
        :key="editorKey"
        class="side__editor"
        @updateTag="updateTag"
        @deleteTag="deleteTag"
      />
    </div>
  </main>
</template>

<script>
import TagList from './TagList/TagList.vue';
import TagEditor from './TagEditor/TagEditor.vue';
import TagCreateForm from './TagCreateForm/TagCreateForm.vue';

export default {
  name: 'TagListPage',
  components: {
    TagList,
    TagEditor,
    TagCreateForm,
  },
  data() {
    return {
      tags: this.initialTags,
      selectedTagId: null,
    };
  },
  props: {
    initialTags: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    editorKey() {
      return this.selectedTagId
        ? `tag-editor-${this.selectedTagId}`
        : 'tag-editor-no-selected';
    },
    categories() {
      return this.tags.filter((tag) => tag.tag_type !== 'tag');
    },
    rootCategories() {
      return this.categories.filter((tag) => tag.parent_id === null);
    },
    tagTypeTags() {
      return this.tags.filter((tag) => tag.tag_type === 'tag');
    },
    selectedTag() {
      return this.tags.find((tag) => tag.id === this.selectedTagId);
    },
  },
  methods: {
    selectTag(tagId) {
      if (this.selectedTagId === tagId) {
        this.selectedTagId = null;
        return;
      }
      this.selectedTagId = tagId;
    },
    async createTag(tag) {
      this.tags.push(tag);
      this.selectedTagId = tag.id;
    },
    async updateTag(tag) {
      this.tags = this.tags.map((t) => {
        if (t.id === tag.id) {
          return tag;
        }
        return t;
      });
    },
    async deleteTag(tag) {
      this.tags = this.tags.filter((t) => t.id !== tag.id);
      this.selectedTagId = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  display: flex;

  &__main {
    flex: 0 0 500px;
  }

  &__side {
    flex: 1 0 0;

    &:nth-child(n + 2) {
      margin-left: 20px;
    }
  }
}

.main {
  &__heading {
    &:nth-child(n + 2) {
      margin-top: 40px;
    }
  }
}

.side {
  &__editor {
    position: sticky;
    top: 20px;
  }
}
</style>
